export const app = {
  title: 'مساعد اللغة الذكي',
  subtitle: 'تعلم اللغات بذكاء',
  signin: 'تسجيل الدخول',
  signout: 'تسجيل الخروج'
};